/**
 * Base URL de la API v1 (sin barra final).
 *
 * Por defecto **`/api/v1`** (relativo al origen del SPA):
 * - `npm start`: `src/setupProxy.js` reenvía `/api` al backend (`REACT_APP_PROXY_TARGET`, por defecto `127.0.0.1:8080`).
 * - `npm run build`: el servidor debe proxy `/api/v1` al backend, o define `REACT_APP_API_URL` al construir.
 *
 * Otro puerto en dev (p. ej. `artisan serve`): `REACT_APP_API_URL=http://127.0.0.1:8000/api/v1` y reinicia `npm start`.
 */
const envUrl = (process.env.REACT_APP_API_URL || "").trim();

export const api = {
  API_URL:
    envUrl.length > 0
      ? envUrl
      : "/api/v1",
};